/* eslint-disable react/prop-types */
import { useCallback, useContext, useEffect, useState } from "react";
import "./styles.css";
import { IoLogoWhatsapp, IoMenu } from "react-icons/io5";
import { IoIosNotifications } from "react-icons/io";
import SideMenu from "../SideMenu/SideMenu";
import { Link } from "react-router-dom";
import { Context } from "../../hooks/useAuthContext";
import api from "../../services/axiosConfig";
import ModalMensagens from "../ModalMensagens/ModalMensagens";

function Header({ urlFoto }) {
  const { userData } = useContext(Context);
  const [menuAberto, setMenuAberto] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [modalAberto, setModalAberto] = useState(false);

  const toggleModalMensagens = () => {
    setModalAberto(!modalAberto);
  };

  const redirectWhatsapp = (e) => {
    e.stopPropagation();
    let link = userData?.linkGrupo;
    if (link) {
      if (!/^https?:\/\//i.test(link)) {
        link = `https://${link}`;
      }
      window.location.href = link;
    }
  };

  const fetchUnreadCount = useCallback(async () => {
    if (!userData?._id) return;
    try {
      const response = await api.get(`/mensagens/unread/count/?userId=${userData._id}`);
      setUnreadCount(response.data.unreadCount);
    } catch (error) {
      console.error("Falha ao buscar contagem de notificações:", error);
      setUnreadCount(0);
    }
  }, [userData?._id])
  
  useEffect(() => {
      fetchUnreadCount();
  }, [userData]);

  return (
    <div className="header">
      <div className="headerItems">
        <div className="infoProfile">
          <div className="profilePicture">
            <Link to={"/"}>
              <img
                src={urlFoto || "https://i.imgur.com/2C6Faoh.png"}
                alt="foto de perfil padrão da link do bem"
              />
            </Link>
          </div>
        </div>

        <div className="menuIcon">
          {userData?.linkGrupo && <IoLogoWhatsapp color="green" style={{ fontSize: 30, marginRight: 15, cursor: 'pointer' }} onClick={redirectWhatsapp} />}
          
          <div className="notification-icon-wrapper" onClick={toggleModalMensagens}>
            <IoIosNotifications color="white" style={{ fontSize: 35, cursor: 'pointer' }} />
            {unreadCount > 0 && (
              <span className="notification-badge">
                {unreadCount}
              </span>
            )}
          </div>

          <IoMenu style={{ fontSize: 35, cursor: 'pointer' }}  onClick={() => setMenuAberto(true)} />
        </div>
      </div>

       <ModalMensagens 
        isOpen={modalAberto} 
        toggle={toggleModalMensagens}
        onMessagesUpdate={fetchUnreadCount} 
       />
      <SideMenu isOpen={menuAberto} onClose={() => setMenuAberto(false)} />
    </div>
  );
}

export default Header;